module.exports = __webpack_public_path__ + "img/roll12.27d65f62.png";